import React, { useCallback, useEffect, useState, useRef } from 'react'
import { FaSearch } from 'react-icons/fa'
import { CloseText, Input, SearchTextContainer } from 'components'
import { useDebounce } from "use-debounce"
import classnames from 'classnames'

const InputSearch = React.forwardRef(({ onChange, value, className, minLengthToSearch = 2, ...rest }, ref) => {
  const localRef = useRef()
  ref = ref || localRef
  const [text, setText] = useState(value)
  const [debouncedText] = useDebounce(text, 400)

  useEffect(() => {
    if (
      typeof debouncedText === 'string' &&
      (
        debouncedText.length === 0 ||
        debouncedText.length > minLengthToSearch
      )
    ) {
      onChange(debouncedText)
    }
  }, [debouncedText])

  const handleChange = useCallback(({ target: { value } }) => {
    setText(value)
  }, [setText])

  const handleClear = useCallback(() => {
    setText('')
    setTimeout(() => ref?.current?.focus())
  }, [setText])

  return (
    <SearchTextContainer>
      <Input
        type="text"
        onChange={handleChange}
        value={text}
        maxLength={100}
        autoComplete="off"
        ref={ref}
        className={classnames(className, 'pr-4')}
        {...rest}
      />
      {text ? <CloseText onClick={handleClear}/> : <FaSearch className="inner-icon"/>}
    </SearchTextContainer>
  )
})

export default InputSearch
